.TextFieldLabel {
  z-index: 1;
  display: grid;
  grid: auto / 1fr;
  gap: var(--space-xs);
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid var(--neutral-1);
  padding: var(--space-sm);
  background: var(--white);
  transition: border-color 150ms;

  &:has([data-slot="suffix"]) {
    grid-template-columns: 1fr auto;
    align-items: center;

    &:has(textarea) {
      align-items: flex-end;
    }
  }

  &.hidden {
    display: none;
  }

  span:first-of-type {
    display: inline-flex;
    justify-content: space-between;
    font-size: 0.8125rem;
    color: var(--neutral);
    grid-column: 1 / -1;

    [data-slot="error-icon"] {
      color: var(--accent-2);
      animation: fadeIn 50ms ease-out;
      width: 14px;
      height: 14px;
    }
  }

  [data-slot="suffix"] {
    text-align: right;
    font-size: 0.875rem;
    font-weight: normal;
    color: var(--neutral);
  }

  &:hover {
    border-color: var(--neutral);
    box-shadow: var(--smooth-shadow);
  }

  &:has(input:read-only),
  &:has(textarea:read-only),
  &:has(input:disabled),
  &:has(textarea:disabled) {
    pointer-events: none;
    cursor: default;
    background-color: var(--disabled-background);
    border-color: var(--neutral-1);
    box-shadow: none;

    span:first-of-type {
      color: var(--neutral-1);
    }

    [data-slot="suffix"] {
      color: var(--neutral-1);
    }
  }

  &:has(input[aria-invalid="true"]),
  &:has(textarea[aria-invalid="true"]) {
    border-color: var(--accent-2);
  }

  &:focus-within {
    border-color: var(--neutral);
    box-shadow: var(--smooth-shadow);
    transition: border-color 150ms;
  }

  input,
  textarea {
    width: 100%;
    border: none;
    font-family: inherit;
    font-size: inherit;
    background-color: transparent;
    color: var(--black);

    &:disabled {
      opacity: 1;
      color: var(--disabled-color);
      background: transparent;
    }

    &:focus-visible,
    &:focus {
      outline: none;
    }
  }

  textarea {
    resize: none;
  }

  [type="number"] {
    -webkit-appearance: textfield;
    appearance: textfield;
  }
  input[type="number"]::-webkit-inner-spin-button {
    appearance: none;
  }

  ::placeholder {
    color: var(--neutral-1);
    font-size: 0.875rem;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
